"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var api_request_1 = require("../api_request");
var related_articles_1 = require("../shared/related_articles");
var url_helpers_1 = require("../shared/url_helpers");
var RRelatedArticles = related_articles_1.default;
var ArticleGridEmbed = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleGridEmbed, _super);
    function ArticleGridEmbed(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            articles: [],
        };
        return _this;
    }
    ArticleGridEmbed.prototype.componentDidMount = function () {
        var _this = this;
        var req = api_request_1.V3.get(url_helpers_1.default.articlesMultiplePath(), { slugs: this.props.slugs });
        req.then(function (response) {
            _this.setState({ articles: response.articles });
        });
    };
    ArticleGridEmbed.prototype.render = function () {
        return (React.createElement(RRelatedArticles, { heading: this.props.heading, articles: this.state.articles }));
    };
    return ArticleGridEmbed;
}(React.Component));
exports.default = ArticleGridEmbed;
//# sourceMappingURL=article_grid_embed.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/embeds/article_grid_embed.js
// module id = kZ1i
// module chunks = 20 21